// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"672":"bootstrap","729":"jquery"}[chunkId] + "." + {"672":"ca5f9972fe342977aeca","729":"439ebfd1960c65745634"}[chunkId] + ".js";
};